export const article = [
  {
    articleId: 37,
    url: "como-cancelar-tu-suscripcion",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "¿Cómo cancelar tu suscripción?",
    content: 
      <>
        <div className="rowLine">
          <p>Si deseas realizar la dada de baja de tu suscripción actual <b>desde web (computador)</b>:</p>
          <ul className="disc">
            <li>Tienes que ingresar a <a href="https://megago.cl/cuenta/plan" target="_blank">megago.cl/cuenta/plan</a>, donde te figurará el botón "Cancelar mi plan". Presiónalo para que te lleve al recuadro de confirmación, donde te aparecerá la fecha de vigencia que tendrá tu cuenta full.</li>
            <li>Confirma tu cancelación con el botón enmarcado de color rojo "Cancelar suscripción" donde posteriormente te aparecerá que se realizó la cancelación de tu suscripción exitosamente.</li>
          </ul>
        </div>
        <div className="rowLine">
          <p>Si deseas realizar la dada de baja de tu suscripción actual <b>desde un celular:</b></p>
          <ul className="disc">
            <li>Tienes que ingresar a <a href="https://megago.cl/cuenta/plan" target="_blank">megago.cl/cuenta/plan</a>, donde te figurará el botón "Cancelar mi plan". Presiónalo para que te lleve al recuadro de confirmación, donde te aparecerá la fecha de vigencia que tendrá tu cuenta full.</li>
            <li>Confirma tu cancelación con el botón enmarcado de color rojo "Cancelar suscripción" donde posteriormente te aparecerá que se realizó la cancelación de tu suscripción exitosamente.</li>
          </ul>
        </div>
        <div className="row">
          <p>Recuerda que al momento de realizar exitosamente tu cancelación de suscripción recibirás un correo confirmando el proceso de cancelación exitosa al correo vinculado a la suscripción.</p>
          <p>*Si al realizar el proceso te arroja error, no dudes en contactarte con nosotros a <a href="mailto: contacto@megago.cl">contacto@megago.cl</a> para poder ayudarte*</p>
        </div>
      </>
  }
];